"use strict";var ComponentDef = require("../ComponentDef");

module.exports = function beginComponent(
componentsContext,
component,
key,
ownerComponentDef)
{
  var componentId = component.id;
  var componentDef = componentsContext.k_ = new ComponentDef(
  component,
  componentId,
  componentsContext);

  componentsContext.f_._V_[
  componentId] =
  true;
  componentsContext.b_.push(componentDef);

  var out = componentsContext.z_;
  out.bc(component, key, ownerComponentDef && ownerComponentDef.i_);
  return componentDef;
};